/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductFitmentModule() {
		var $fitmentModules;

		function HandleFitmentDataResponse({$fitmentModule}) {
			return function (evt, response) {
				const fitmentRows = Array.isArray(response.data) ? response.data : [];
				const fitmentLimit = 5;

				// process rows into YMM data that we use for display
				const ymmRows = [];
				fitmentRows.forEach((row) => {
					ymmRows.push({
						year: row.year,
						make: row.make,
						model: row.model,
						trims: row.trims,
						engines: row.engines,
						idx: ymmRows.length + 1,
					});
				});

				// create html for display
				const ymmHtml = ymmRows.map((row) => {
					return `<tr class="fitment-row ${row.idx > fitmentLimit ? 'fitment-hidden' : ''}">
						<td class="fitment-year">${row.year}</td>
						<td class="fitment-make">${row.make}</td>
						<td class="fitment-model">${row.model}</td>
						<td class="fitment-trim">${row.trims.join(', ')}</td>
						<td class="fitment-engine">${row.engines.join(', ')}</td>
					</tr>`;
				}).join('');

				const hasTrimData = ymmRows.some((row) => row.trims.length > 0 );
				const hasEngineData = ymmRows.some((row) => row.engines.length > 0 );

				const $fitmentTable = $fitmentModule.find('.fitment-table');
				$fitmentTable.find('.fitment-table-body').html(ymmHtml);

				// Manage whether we show trim column
				if (hasTrimData) {
					$fitmentTable.removeClass('hide-trim-data');
				} else {
					$fitmentTable.addClass('hide-trim-data');
				}

				// Manage whether we show engine column
				if (hasEngineData) {
					$fitmentTable.removeClass('hide-engine-data');
				} else {
					$fitmentTable.addClass('hide-engine-data');
				}

				// Manage expander
				$fitmentModule.find('.full-count').text(ymmRows.length);
				$fitmentModule.find('.closed-count-total').text(ymmRows.length - fitmentLimit);
				if (ymmRows.length > fitmentLimit) {
					$fitmentModule.find('.fitment-table-wrap').addClass('fitment-closed');
					$fitmentModule.find('.fitment-expander').show();
				} else {
					$fitmentModule.find('.fitment-table-wrap').removeClass('fitment-closed');
					$fitmentModule.find('.fitment-expander').hide();
				}

				if (ymmRows.length > 0) {
					$fitmentModule.addClass('has-fitment-data');
				} else {
					$fitmentModule.removeClass('has-fitment-data');
				}

				$fitmentModule.addClass('loaded');
			};
		}

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$fitmentModules = rp$('.product-fitment-module');


			const handleUnobserve = (element) => {
				observer.unobserve(element);
			};

			const handleIntersect = (intersects) => {
				for (let i=0; i < intersects.length; i++) {
					const item = intersects[i];
					if (item.intersectionRatio > 0) {
						const moduleEle = item.target;
						handleUnobserve(moduleEle);
						loadProductFitmentData(moduleEle);
					}
				}
			};

			const loadProductFitmentData = (moduleEle) => {
				rp$(document).trigger('productGetFitmentData:request', {
					catalog: moduleEle.dataset.catalog,
					skuStripped: moduleEle.dataset.skuStripped,
					brand: moduleEle.dataset.brand,
				});
			};

			let observer = null;
			if ('IntersectionObserver' in window) {
				observer = new IntersectionObserver(handleIntersect, {
					root: null,
					rootMargin: '0px',
					threshold: 0,
				});
				document.querySelectorAll('.product-fitment-module').forEach((element) => {
					observer.observe(element);
				});
			} else {
				const module = document.querySelector('.product-fitment-module');
				if (module) {
					loadProductFitmentData(module);
				}
			}

			rp$.each($fitmentModules, function DropDownMenu_Iterator(idx, fitmentModule) {
				var $fitmentModule = rp$(fitmentModule);
				var wrapper = $fitmentModule.find('.fitment-table-wrap');

				const eventHandler = HandleFitmentDataResponse({
					$fitmentModule
				});

				rp$(document).off('productGetFitmentData:response', eventHandler);
				rp$(document).on('productGetFitmentData:response', eventHandler);

				$fitmentModule.on('click', '.fitment-expander', function Expand_Fitment() {
					if(wrapper.hasClass('fitment-closed')){
						wrapper.removeClass('fitment-closed');
					} else {
						wrapper.addClass('fitment-closed');
					}
				});
			});
		}

		function HandleNewProductImagesHtml(evt, html) {
			rp$('.product-fitment-module').html(html);
			attachEvents();
		}

		rp$(document).off('setProductFitment:html', HandleNewProductImagesHtml);
		rp$(document).on('setProductFitment:html', HandleNewProductImagesHtml);

		$onReady({
			rp$, window,
			label: 'product_fitment',
			fn: attachEvents,
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
